import React from 'react';
import { t } from '@i18n/i18n';
import navTranslations from '@i18n/translations/components/navigation/nav.json';
import LangA from '../../i18n/LangA';
import { useI18nInitNamespace } from '../../i18n/useI18nInitNamespace';
import useCurrentLanguage from '../../i18n/useCurrentLanguage';

import BlogIcon from '../../images/navigation/blog-icon.webp';
import CaseStudyIcon from '../../images/navigation/case-study-icon.webp';
import ContactPhoneIcon from '../../images/navigation/contact-phone-icon.webp';
import DataIcon from '../../images/navigation/data-icon.webp';
import DrawerIcon from '../../images/navigation/drawer-icon.webp';
import EmailFinderIcon from '../../images/navigation/email-finder-icon.webp';
import EmailScoreIcon from '../../images/navigation/email-score-icon.webp';
import GearIcon from '../../images/navigation/gear-icon.webp';
import HeartbeatIcon from '../../images/navigation/heartbeat-icon.webp';
import MediaKitIcon from '../../images/navigation/media-kit-icon.webp';
import NewsIcon from '../../images/navigation/news-icon.webp';
import PartnerIcon from '../../images/navigation/partners-icon.webp';
import PhoneIcon from '../../images/navigation/phone-icon.webp';
import ProfileIcon from '../../images/navigation/profile-icon.webp';
import SecurityIcon from '../../images/navigation/security-icon.webp';
import StarIcon from '../../images/navigation/star-icon.webp';
import SuitcaseIcon from '../../images/navigation/suitcase-icon.webp';
import ValidationIcon from '../../images/navigation/validation-icon.webp';
import DmarcIcon from '@images/icons/dmarc-starter.png';
import OnlineIcon from '../../images/navigation/event_nav_icon.png';
import SettingsIcon from '../../images/icons/settings.inline.webp';
import GuidesIcon from '../../images/navigation/case_studies_nav.png';
import ReviewsIcon from '../../images/navigation/reviews_nav.png';
import ServerIcon from '../../images/icons/server_icon_check_blue.png';
import ToolsIcon from '../../images/icons/toolkit-icon-blue.png';
import EmailDeliverabilityIcon from '../../images/icons/deliverability-icon-blue.webp';
import NavCol from './navigation-components/nav-col';
import WarmupIcon from '../../images/icons/icon-warmup-blue.png';
import ReportsIcon from '../../images/navigation/reports-icon.webp';

const Nav = ({ latestBlogArticles, customNavElements = [], customPricingLink = '' }) => {
  useI18nInitNamespace('nav', navTranslations, true);

  const { isEs } = useCurrentLanguage();

  const menu = [
    {
      parent: {
        linkText: t('a_Products'),
        title: t('You_put'),
        href: '/services/',
        hasDropdown: true,
        class: 'products',
        titleId: 'head_navigation_products',
        shouldNavigate: true,
        customTitle: 'products',
      },
      dropdown: [
        {
          additionalClass: null,
          title: t('p_PRODUCTS'),
          titleId: 'products_navigation_products',
          items: [
            {
              insideTitle: t('new_validation'),
              titleId: 'products_navigation_validation_services',
            },
            {
              linkText: t('Email_Validation'),
              subText: t('Clean_your1'),
              title: t('Clean_your'),
              href: '/services/email-validation',
              img: ValidationIcon,
              width: '24',
              height: '25',
              headId: 'navigation_validation_title',
              subTextId: 'navigation_validation_text',
              iconId: 'navigation_validation_icon',
            },
            {
              linkText: t('Email_Activity'),
              subText: t('Discover_most'),
              title: t('Find_and'),
              href: '/services/activity-data',
              img: DataIcon,
              width: '26',
              height: '25',
              headId: 'navigation_activity_title',
              subTextId: 'navigation_activity_text',
              iconId: 'navigation_activity_icon',
            },
            {
              linkText: t('Email_Score'),
              subText: t('AI_email'),
              title: t('Email_scoring'),
              href: '/services/email-scoring/',
              img: EmailScoreIcon,
              width: '26',
              height: '19',
              headId: 'navigation_scoring_title',
              subTextId: 'navigation_scoring_text',
              iconId: 'navigation_scoring_icon',
            },
            {
              linkText: t('Email_Finder'),
              subText: t('Email_Finder_Description'),
              title: t('Email_Finder'),
              href: '/services/email-finder/',
              img: EmailFinderIcon,
              width: '26',
              height: '19',
              headId: 'navigation_finder_title',
              subTextId: 'navigation_finder_text',
              iconId: 'navigation_finder_icon',
            },
          ],
        },
        {
          additionalClass: null,
          items: [
            {
              insideTitle: t('new_deliverability'),
              titleId: 'products_navigation_deliverabily_services',
            },
            {
              linkText: t('warmup_title'),
              subText: t('warmup_text'),
              title: t('warmup_title'),
              href: '/services/email-warmup/',
              img: WarmupIcon,
              width: '20',
              height: '25',
              headId: 'navigation_warmup_title',
              subTextId: 'navigation_warmup_text',
              iconId: 'navigation_warmup_icon',
            },
            {
              linkText: t('dmarc_title'),
              subText: t('dmarc_text'),
              title: t('dmarc_title'),
              href: '/services/dmarc-monitor/',
              img: DmarcIcon,
              width: '20',
              height: '25',
              headId: 'navigation_dmarc_title',
              subTextId: 'navigation_dmarc_text',
              iconId: 'navigation_dmarc_icon',
            },
            {
              linkText: t('Blacklist_Monitor'),
              subText: t('Real_time'),
              title: t('Get_notifications'),
              href: '/services/blacklist-monitoring/',
              img: HeartbeatIcon,
              width: '26',
              height: '19',
              headId: 'navigation_blacklist_title',
              subTextId: 'navigation_blacklist_text',
              iconId: 'navigation_blacklist_icon',
            },
            {
              linkText: t('inbox_placement_test'),
              subText: t('test_inbox'),
              title: t('Test_for'),
              href: '/services/inbox-placement-test/',
              img: DrawerIcon,
              width: '26',
              height: '23',
              headId: 'navigation_inbox_title',
              subTextId: 'navigation_inbox_text',
              iconId: 'navigation_inbox_icon',
            },
            {
              linkText: t('email_server_test'),
              subText: t('diagnose_email'),
              title: t('Test_for'),
              href: '/services/email-server-test/',
              img: ServerIcon,
              width: '26',
              height: '23',
              headId: 'navigation_testing_title',
              subTextId: 'navigation_testing_text',
              iconId: 'navigation_testing_icon',
            },
            {
              linkText: t('tools_text'),
              subText: t('tools_desc'),
              title: t('tools_text'),
              href: '/email-deliverability-tools/',
              img: ToolsIcon,
              width: '26',
              height: '23',
              headId: 'navigation_tools_title',
              subTextId: 'navigation_tools_text',
              iconId: 'navigation_tools_icon',
            },
            {
              linkText: t('email_deliverability_text'),
              subText: t('email_deliverability_desc'),
              title: t('email_deliverability_text'),
              href: '/services/email-deliverability-consulting',
              img: EmailDeliverabilityIcon,
              width: '26',
              height: '23',
              headId: 'email_deliverability_consulting_title',
              subTextId: 'email_deliverability_consulting_text',
              iconId: 'email_deliverability_consulting_icon',
            },
          ],
        },
        {
          additionalClass: 'nav__dropdown-wrap-text',
          title: 'API',
          titleId: 'products_navigation_api',
          items: [
            {
              linkText: t('api_services'),
              subText: null,
              title: t('api_services'),
              href: '/api/',
              img: null,
              headId: 'navigation_api_title',
            },
            {
              linkText: t('Email_Validation_api'),
              subText: null,
              title: t('Email_Validation_api'),
              href: '/api/email-validation-api/',
              img: null,
              headId: 'navigation_verification_api_title',
            },
            {
              linkText: t('Email_Finder_API'),
              subText: null,
              title: t('Email_Finder_API'),
              href: '/api/email-finder-api/',
              img: null,
              headId: 'navigation_finder_api_title',
            },
            {
              insideTitle: t('p_FREE_TOOLS'),
              titleId: 'products_navigation_tools',
            },
            {
              linkText: t('overview'),
              subText: null,
              title: t('overview'),
              href: '/free-email-tools/',
              img: null,
              headId: 'navigation_finder_tools',
            },
            {
              linkText: t('Free_Email_Verifier'),
              subText: null,
              title: t('Free_Email_Verifier'),
              href: '/free-email-verifier/',
              img: null,
              headId: 'navigation_verifier_title',
            },
            {
              linkText: t('Free_List_Evaluator'),
              subText: null,
              title: t('Free_List_Evaluator'),
              href: '/email-list-evaluator/',
              img: null,
              headId: 'navigation_evaluator_title',
            },
            {
              linkText: t('Blacklist_Checker'),
              subText: null,
              title: t('Blacklist_Checker'),
              href: '/services/blacklist-checker/',
              img: null,
              headId: 'navigation_checker_title',
            },
            {
              linkText: t('dmarc_checker'),
              subText: null,
              title: t('dmarc_checker'),
              href: '/dmarc-checker/',
              img: null,
              headId: 'navigation_dmarc_checker_title',
            },
          ],
        },
      ],
    },
    {
      parent: {
        linkText: t('Solutions'),
        class: 'enterprise',
        title: t('Solutions'),
        hasDropdown: true,
        href: '/',
        titleId: 'head_navigation_enterprise',
        customTitle: t('Solutions'),
        shouldNavigate: false,
      },
      dropdown: [
        {
          additionalClass: 'nav__dropdown-split-col',
          titleId: 'products_navigation_tools',
          title: t('Solutions'),
          items: [
            {
              linkText: t('a_Enterprise'),
              subText: null,
              title: t('a_Enterprise'),
              href: '/enterprise/',
              img: null,
              headId: 'navigation_evaluator_title',
            },
            {
              linkText: t('Agencies'),
              subText: null,
              title: t('Agencies'),
              href: '/solutions/agencies/',
              img: null,
              headId: 'navigation_verifier_title',
            },
            {
              linkText: t('Business'),
              subText: null,
              title: t('Business'),
              href: '/solutions/business-development/',
              img: null,
              headId: 'navigation_checker_title',
            },
            {
              linkText: t('class_action_settlement_email_validation'),
              subText: null,
              title: t('class_action_settlement_email_validation'),
              href: '/solutions/class-action-settlement-email-validation/',
              img: null,
              headId: 'navigation_class_action_settlement_email_validation_title',
            },
            {
              linkText: t('Developers'),
              subText: null,
              title: t('Developers'),
              href: '/solutions/developers/',
              img: null,
              headId: 'navigation_send_time_title',
            },
            {
              linkText: t('Email_marketing'),
              subText: null,
              title: t('Email_marketing'),
              href: '/solutions/email-marketing/',
              img: null,
              headId: 'navigation_send_time_title1',
            },
            {
              linkText: 'SMB',
              subText: null,
              title: 'SMB',
              href: '/solutions/smb/',
              img: null,
              headId: 'navigation_send_time_title2',
            },
          ],
        },
      ],
    },
    {
      parent: {
        class: 'pricing',
        linkText: t('a_Pricing'),
        title: t('ZeroBounce_Pricing'),
        href: customPricingLink || '/email-validation-pricing',
        hasDropdown: false,
        titleId: 'head_navigation_pricing',
        customTitle: 'pricing',
      },
      dropdown: null,
    },
    {
      parent: {
        class: 'resources',
        hasDropdown: true,
        href: '/docs/',
        linkText: t('a_Resources'),
        title: t('ZeroBounce_Documentation'),
        titleId: 'head_navigation_resources',
        customTitle: 'resources',
      },
      dropdown: [
        {
          additionalClass: 'resources--dropdown',
          title: null,
          items: [
            {
              linkText: t('Blog'),
              subText: null,
              title: t('Blog'),
              href: 'https://www.zerobounce.net/blog',
              img: BlogIcon,
              width: '25',
              height: '25',
              headId: 'navigation_blog_title',
              subTextId: 'navigation_blog_text',
              iconId: 'navigation_blog_icon',
            },
            {
              linkText: t('Integrations'),
              subText: null,
              title: t('Integrations'),
              href: '/integrations/',
              img: GearIcon,
              width: '25',
              height: '25',
              headId: 'navigation_integrations_title',
              subTextId: 'navigation_integrations_text',
              iconId: 'navigation_integrations_icon',
            },
            {
              linkText: t('Case_Studies1'),
              subText: null,
              title: t('Case_Studies1'),
              href: '/case-studies/',
              img: CaseStudyIcon,
              width: '26',
              height: '25',
              headId: 'navigation_studies_title',
              subTextId: 'navigation_studies_text',
              iconId: 'navigation_studies_icon',
            },
            {
              linkText: t('email_guides'),
              subText: null,
              title: t('email_guides'),
              href: '/email-guides/',
              img: GuidesIcon,
              width: '19',
              height: '20',
              headId: 'email_guides',
              subTextId: '',
              iconId: 'email_guides_icon',
              additionalClass: 'small-icon--nav',
            },
            {
              linkText: t('p_ZEROBOUNCE_REPORTS'),
              subText: null,
              title: t('p_ZEROBOUNCE_REPORTS'),
              href: null,
              img: ReportsIcon,
              width: '19',
              height: '20',
              headId: 'zerobounce_reports',
              iconId: 'navigation_reports_icon',
              subMenu: [
                {
                  linkText: t('Email_Decay'),
                  subText: null,
                  title: t('Email_Decay'),
                  href: '/email-list-decay/',
                  img: null,
                  headId: 'navigation_decay_title',
                },
                {
                  linkText: t('Email_statistics'),
                  subText: null,
                  title: t('Email_statistics'),
                  href: '/email-statistics-report/',
                  img: null,
                  headId: 'navigation_statistics_title',
                },
                {
                  linkText: t('GenZ_Report'),
                  subText: null,
                  title: t('GenZ_Report'),
                  href: '/GenZ-work-report/',
                  img: null,
                  headId: 'navigation_genz_title',
                },
              ],
            },
            {
              linkText: t('ZeroBounce_iOS_App'),
              subText: null,
              title: t('ZeroBounce_iOS_App'),
              href: '/ios/',
              img: PhoneIcon,
              width: '14',
              height: '24',
              headId: 'navigation_ios_title',
              subTextId: 'navigation_ios_text',
              iconId: 'navigation_ios_icon',
            },
          ],
        },
        {
          additionalClass: null,
          title: t('SUPPORT'),
          titleId: 'resources_navigation_support',
          items: [
            {
              linkText: t('Documentation'),
              subText: null,
              title: t('Documentation'),
              href: '/docs/',
              img: null,
              headId: 'navigation_documentation_title',
            },
            {
              linkText: t('Help_Desk'),
              subText: null,
              title: t('Help_Desk'),
              href: '/contact-us/',
              img: null,
              headId: 'navigation_help_desk_title',
            },
            {
              linkText: t('FAQ'),
              subText: null,
              title: t('FAQ'),
              href: '/docs/frequently-asked-questions/',
              img: null,
              headId: 'navigation_faq_title',
            },
            // {
            //   linkText: t('Product_Updates'),
            //   subText: null,
            //   title: t(''),
            //   href: '#',
            //   img: null,
            // },
          ],
        },
        {
          additionalClass: null,
          title: t('Api'),
          titleId: 'resources_navigation_api',
          items: [
            {
              linkText: t('Quickstart'),
              subText: null,
              title: t('Quickstart'),
              href: '/docs/',
              img: null,
              headId: 'navigation_quickstart_title',
            },
            {
              linkText: t('AI_Scoring'),
              subText: null,
              title: t('AI_Scoring'),
              href: '/docs/ai-scoring-api/',
              img: null,
              headId: 'navigation_ai_scoring_title',
            },
            {
              linkText: t('API_Dashboard'),
              subText: null,
              title: t('API_Dashboard'),
              href: '/docs/api-dashboard/',
              img: null,
              headId: 'navigation_dashboard_title',
            },
            {
              linkText: t('API_Wrappers'),
              subText: null,
              title: t('API_Wrappers'),
              href: '/docs/zerobounce-api-wrappers/',
              img: null,
              headId: 'navigation_wrappers_title',
            },
            {
              linkText: t('API_Status'),
              subText: null,
              title: t('API_Status'),
              href: 'https://status.zerobounce.net',
              img: null,
              headId: 'navigation_api_status_title',
            },
          ],
        },
        {
          additionalClass: null,
          title: t('Email_Types'),
          titleId: 'resources_navigation_types',
          items: [
            { linkText: t('Spam_Traps'), href: '/spam-traps/', img: null, headId: 'navigation_spam_traps_title' },
            { linkText: t('Catch-all_Emails'), href: '/catch-all-emails/', img: null, headId: 'navigation_catch_all_emails_title' },
            { linkText: t('Abuse_Email'), href: '/abuse-emails/', img: null, headId: 'navigation_abuse_emails_title' },
            { linkText: t('Disposable_Email'), href: '/disposable-emails/', img: null, headId: 'navigation_disposable_title' },
            { linkText: t('Clean_Email'), href: '/clean-email/', img: null, headId: 'navigation_clean_email_title' },
            { linkText: t('no_reply_emails'), href: '/no-reply-emails/', img: null, headId: 'navigation_no_reply_emails_title' },
            { linkText: t('bounced_emails'), href: '/bounced-emails/', img: null, headId: 'navigation_bounced_emails_title' },
            { linkText: t('invalid_emails'), href: '/invalid-emails/', img: null, headId: 'navigation_invalid_emails_title' },
          ],
        },
        {
          additionalClass: null,
          title: t('Email_Deliverability1'),
          titleId: 'resources_navigation_deliverability',
          items: [
            {
              linkText: t('Email_Deliverability1'),
              subText: null,
              title: t('Email_Deliverability1'),
              href: '/email-deliverability/',
              img: null,
              headId: 'navigation_deliverability_title',
            },
            {
              linkText: t('bounce_rates_email_deliverability'),
              subText: null,
              title: t('bounce_rates_email_deliverability'),
              href: '/bounce-rates-email-deliverability/',
              img: null,
              headId: 'navigation_bounce_rates_title',
            },
            {
              linkText: t('anti_greylisting'),
              subText: null,
              title: t('anti_greylisting'),
              href: '/anti-greylisting/',
              img: null,
              headId: 'navigation_anti_greylisting_title',
            },
            {
              linkText: t('Mailchimp_Omnivore'),
              subText: null,
              title: t('Mailchimp_Omnivore'),
              href: '/mailchimp-omnivore/',
              img: null,
              headId: 'navigation_deliverability_title',
            },
            {
              linkText: t('testing_deliverability'),
              subText: null,
              title: t('testing_deliverability'),
              href: '/test-email-address-deliverability-guide/',
              img: null,
              headId: 'navigation_testing_deliverability_title',
            },
          ],
        },
      ],
    },
    {
      parent: {
        class: 'company',
        hasDropdown: true,
        href: '/why-us/',
        linkText: t('a_Company'),
        title: t('Why_Use'),
        titleId: 'head_navigation_company',
        customTitle: 'company',
      },
      dropdown: [
        {
          additionalClass: 'nav__dropdown-split-col',
          title: null,
          items: [
            {
              linkText: t('About_ZeroBounce'),
              subText: null,
              title: t('ZeroBounce_Team'),
              href: '/zerobounce-team/',
              img: ProfileIcon,
              width: '24',
              height: '25',
              headId: 'navigation_about_title',
              subTextId: 'navigation_about_text',
              iconId: 'navigation_about_icon',
            },
            {
              linkText: t('Why_us'),
              subText: null,
              title: t('Why_us_info'),
              href: '/why-us/',
              img: StarIcon,
              width: '24',
              height: '25',
              headId: 'navigation_why_us_title',
              subTextId: 'navigation_why_us_text',
              iconId: 'navigation_why_us_icon',
            },
            // {
            //   linkText: t('Security'),
            //   subText: null,
            //   title: t('Security'),
            //   href: '#',
            //   img: SecurityIcon,
            // },
            {
              linkText: t('Media_Kit'),
              subText: null,
              title: t('ZeroBounce_Press'),
              href: '/media-press-kit/',
              img: MediaKitIcon,
              width: '19',
              height: '25',
              headId: 'navigation_press_title',
              subTextId: 'navigation_press_text',
              iconId: 'navigation_press_icon',
            },
            {
              linkText: t('Newsroom'),
              subText: null,
              title: t('Newsroom_Archives'),
              href: 'https://www.zerobounce.net/blog/category/newsroom',
              img: NewsIcon,
              width: '25',
              height: '25',
              headId: 'navigation_newsroom_title',
              subTextId: 'navigation_newsroom_text',
              iconId: 'navigation_newsroom_icon',
            },
            {
              linkText: t('Jobs'),
              subText: null,
              title: t('Career_Opportunities'),
              href: '/careers/',
              img: SuitcaseIcon,
              width: '26',
              height: '24',
              headId: 'navigation_jobs_title',
              subTextId: 'navigation_jobs_text',
              iconId: 'navigation_jobs_icon',
            },
            {
              linkText: t('Partners'),
              subText: null,
              title: t('ZeroBounce_Partnership'),
              href: '/partners',
              img: PartnerIcon,
              width: '26',
              height: '22',
              headId: 'navigation_partners_title',
              subTextId: 'navigation_partners_text',
              iconId: 'navigation_partners_icon',
            },
          ],
        },
        {
          additionalClass: 'nav__dropdown-split-col',
          title: null,
          items: [
            {
              linkText: t('Contact'),
              subText: null,
              title: t('ZeroBounce_Contact'),
              href: '/contact-us/',
              img: ContactPhoneIcon,
              width: '25',
              height: '25',
              headId: 'navigation_contact_title',
              subTextId: 'navigation_contact_text',
              iconId: 'navigation_contact_icon',
            },
            {
              linkText: t('Security'),
              subText: null,
              title: t('ZeroBounce_Security'),
              href: '/security/',
              img: SecurityIcon,
              width: '19',
              height: '25',
              headId: 'navigation_security_title',
              subTextId: 'navigation_security_text',
              iconId: 'navigation_security_icon',
            },
            {
              linkText: t('Events'),
              subText: null,
              title: t('ZeroBounce_Events'),
              href: null,
              img: OnlineIcon,
              width: '25',
              height: '25',
              headId: 'navigation_events_title',
              subTextId: 'navigation_events_text',
              iconId: 'navigation_events_icon',
              additionalClass: 'events-submenu',
              subMenu: [
                {
                  linkText: t('upcoming_events'),
                  subText: null,
                  title: t('upcoming_events'),
                  href: '/events/',
                  img: null,
                  headId: 'navigation_upcoming_events_title',
                },
                {
                  linkText: t('on_demand'),
                  subText: null,
                  title: t('on_demand'),
                  href: '/events/#on-demand',
                  img: null,
                  headId: 'navigation_on_demand_title',
                },
                {
                  linkText: t('Email_Day1'),
                  subText: null,
                  title: t('Email_Day1'),
                  href: '/email-day/',
                  img: null,
                  headId: 'navigation_email_day_title',
                },
              ],
            },
            {
              linkText: t('Updates'),
              subText: null,
              title: t('ZeroBounce_Updates'),
              href: '/updates/',
              img: SettingsIcon,
              width: '25',
              height: '25',
              headId: 'navigation_updates_title',
              subTextId: 'navigation_updates_text',
              iconId: 'navigation_updates_icon',
            },
            {
              linkText: t('ZeroBounce_Reviews'),
              subText: null,
              title: t('ZeroBounce_Reviews'),
              href: '/email-validation-reviews/',
              img: ReviewsIcon,
              width: '25',
              height: '25',
              headId: 'navigation_reviews_title',
              subTextId: 'navigation_reviews_text',
              iconId: 'navigation_reviews_icon',
            },
          ],
        },
      ],
    },
  ];

  const filteredMenu = customNavElements.length > 0 ? menu.filter((item) => customNavElements.includes(item.parent.customTitle)) : menu;

  return (
    <nav className="nav">
      <ul>
        {filteredMenu.map(({ parent, dropdown }, index) => (
          <li key={`menu_${index}`}>
            <LangA
              id={parent.titleId}
              href={parent.href}
              title={parent.title}
              onClick={(e) => (parent.hasDropdown && !parent.shouldNavigate ? e.preventDefault() : '')}
            >
              {parent.linkText}
            </LangA>

            {parent.hasDropdown && (
              <div className={`nav__dropdown ${isEs ? `nav__dropdown-${parent.class}-es` : `nav__dropdown-${parent.class}`}`}>
                <div className={`nav__dropdown-cols`}>
                  {dropdown.map(({ title, items, additionalClass, titleId, href }, idx) => (
                    <NavCol
                      key={`menu_${index}_col_${idx}`}
                      colId={`menu_${index}_col_${idx}`}
                      additionClass={additionalClass}
                      isLastItem={dropdown.length - 1 !== idx}
                      items={items}
                      colTitle={title}
                      titleId={titleId}
                      titleHref={href}
                    />
                  ))}
                </div>
              </div>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Nav;
